export { default as StrategyMemberCard } from './StrategyMemberCard';
export type { StrategyMemberCardProps } from './StrategyMemberCard';
